import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { DryHireAssetPicker } from './DryHireAssetPicker';

/**
 * DryHireAllocationModal
 * ──────────────────────
 * Lightweight, center-screen modal for allocating an asset to a dry-hire job.
 * Uses the shared DryHireAssetPicker so changes here stay in lockstep with
 * the inline drawer panel.
 *
 * The Dialog primitive (Radix) auto-centers itself horizontally and vertically
 * regardless of where the trigger element sat on the page.
 */
export function DryHireAllocationModal({
  open,
  onOpenChange,
  api,
  job,
  existingAllocation,
  onSaved,
  onOffHire,
}) {
  if (!job) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md"
        data-testid="dryhire-allocation-modal"
      >
        <DialogHeader>
          <DialogTitle className="font-heading">
            {existingAllocation?.id ? 'Update Allocated Asset' : 'Allocate Asset'} — Job #{job.job_number}
          </DialogTitle>
          <DialogDescription className="text-xs">
            {job.customer_name || ''}
            {job.equipment_type ? ` · ${job.equipment_type}` : ''}
            {' · '}
            {job.start_date}{job.end_date ? ` → ${job.end_date}` : ' → open-ended'}
          </DialogDescription>
        </DialogHeader>

        <DryHireAssetPicker
          api={api}
          job={job}
          existingAllocation={existingAllocation}
          layout="modal"
          onCancel={() => onOpenChange(false)}
          onSaved={() => { onOpenChange(false); onSaved?.(); }}
          onOffHire={onOffHire}
        />
      </DialogContent>
    </Dialog>
  );
}

export default DryHireAllocationModal;
